module.exports = __webpack_public_path__ + "img/features_fraud_insurance_phone.316b7892.jpg";